import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Alert } from "@mui/material";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../services/firebase";
import { db } from "../services/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header"; // ヘッダーをインポート
import { useAuth } from "../contexts/AuthContext";

const AuthPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const { user, loading } = useAuth(); // ログイン状態を取得
  const navigate = useNavigate();

  // ログイン状態をチェックし、既存ユーザーか新規ユーザーかを確認
  useEffect(() => {
    if (!loading && user) {
      checkIfNewUser(user.uid);
    }
  }, [user, loading]);

  const checkIfNewUser = async (authUid: string) => {
    try {
      // Firestoreで既存ユーザーかどうかを確認
      const userDocRef = doc(db, "users", authUid);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        // 新規ユーザーの場合
        navigate("/user-setup"); // ユーザー情報登録画面に遷移
      } else {
        // 既存ユーザーの場合
        navigate("/dashboard"); // ダッシュボードに遷移
      }
    } catch (error) {
      setError((error as Error).message);
    }
  };

  const handleGoogleAuth = async () => {
    try {
      // Google認証のポップアップを表示
      await signInWithPopup(auth, googleProvider);
      // サインイン後は`onAuthStateChanged`で処理が行われる
    } catch (error) {
      setError((error as Error).message);
    }
  };

  return (
    <>
      <Header /> {/* ヘッダーを表示 */}
      <Box
        sx={{
          maxWidth: 400,
          margin: "auto",
          mt: 12, // ヘッダーの高さ分余白を調整
          p: 3,
          borderRadius: 1,
          boxShadow: 3,
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" component="h1" textAlign="center" gutterBottom>
          Googleでログインまたはアカウント作成
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          初めてご利用の方も、既にアカウントをお持ちの方も、Googleで続けることでログインまたはアカウント作成ができます。
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Button
          onClick={handleGoogleAuth}
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Googleで続ける
        </Button>
        <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: "block" }}>
          初めてご利用の方は、Googleでサインイン後に追加情報の入力が求められます。
        </Typography>
      </Box>
    </>
  );
};

export default AuthPage;
